import { Component, OnDestroy, OnInit } from '@angular/core';
import { News, NewsService } from '@/core/services/news.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-top-bar-news',
    standalone: false,
    template: `
        @if (news.length > 0) {
            <div class="topbar-news" data-testid="topbar-news" [attr.data-news-id]="news[0].id">
                <div class="topbar-news-content">
                    <div class="topbar-news-text">
                        <span class="banner-text">
                            {{ news[0].bannerText }}
                        </span>

                        @if (news[0].actionText) {
                            <a
                                class="topbar-news-action"
                                data-testid="topbar-news-action"
                                (click)="news[0].customAction ? news[0].customAction() : (showNewsModal = true)"
                            >
                                {{ news[0].actionText }}
                            </a>
                        }
                    </div>

                    <a class="topbar-news-hide-action" data-testid="topbar-news-dismiss" (click)="hideNews()">
                        <i class="pi pi-times"></i>
                    </a>
                </div>
            </div>
            @if (news[0].dialogTitle && news[0].dialogContent) {
                <p-dialog [header]="news[0].dialogTitle" [(visible)]="showNewsModal" [modal]="true" [closable]="true">
                    <div [innerHTML]="news[0].dialogContent | newlineToBr"></div>
                </p-dialog>
            }
        }
    `,
    styles: `
        .topbar-news {
            background-color: #3b82f6;
            color: white;
            padding: 10px 20px;
        }

        .topbar-news-content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 1rem;
        }

        .topbar-news-text {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            gap: 1rem;
            flex: 1;
            text-align: center;
        }

        .banner-text {
            white-space: normal;
        }

        .topbar-news-action {
            text-decoration: underline;
            color: white;
            cursor: pointer;
            flex-shrink: 0;
        }

        .topbar-news-hide-action {
            color: white;
            cursor: pointer;
            i {
                font-size: 0.8rem;
            }
        }
    `,
})
export class TopBarNewsComponent implements OnInit, OnDestroy {
    showNewsModal = false;
    news: News[] = [];
    subscriptions = new Subscription();

    constructor(private readonly newsService: NewsService) {}

    public ngOnInit(): void {
        this.subscriptions.add(
            this.newsService.news$.subscribe((news) => {
                this.news = news;
            }),
        );
        this.newsService.loadNews();
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public hideNews(): void {
        this.newsService.hideNewsMessage(this.news[0].id);
    }
}
